export const BONUS_POINT = 7;
export const POINT_TIER = {
  YES: true,
  NO: false
};
